import Image from "next/image";

import styles from "./styles.module.css";

export const HeroImage = ({ heroSrc, image }) => {
  return (
    <div className={styles.heroImage}>
      <Image fill src={heroSrc} alt={image?.alt || ""} />
    </div>
  );
};
